<template>
  <article>
    <section class="plarform-search">
      <a href="javascript:void(0);" class="search-icon" @click.stop="search"></a>
      <input v-model="mobile" type="text" class="search-number" placeholder="请输入当前客户手机号">
    </section>
    <section class="search-description" v-if="display">
      <p>当前客流记录无匹配的信息</p>
      <x-button type="primary" @click="createCustomerArchives">新建客户档案</x-button>
    </section>
  </article>
</template>
<script>
import {
  XButton
} from '@lx-frontend/cvux'
import util from '../../../common/util'
import cache from '../../../common/cache'

export default {
  components: {
    XButton
  },
  data () {
    return {
      localArchivesDataKey: 'customerArchivesLocalData',
      store_visit_id: '',
      mobile: '',
      display: false
    }
  },
  created () {
    this.store_visit_id = this.$route.query.store_visit_id
  },
  methods: {
    search () {
      if (!this.mobile) {
        this.showToast('请输入您当前客户手机号')
        return false
      } else if (!util.regexpMap.regexp_mobile.test(this.mobile)) {
        this.showToast('请输入正确的手机号')
        return false
      }
      this.$rest.saleManage.getCustomerInfoByMobile(null, this.mobile).then(res => {
        if (res.code === 0) {
          let data = res.data
          if (data.customer) {
            this.$router.push({
              path: '/salemanage/staff/associatecustomer/' + data.customer.id,
              query: { store_visit_id: this.store_visit_id }
            })
          } else if (data.clue) {
            this.$router.push({
              path: '/salemanage/staff/showcluearchives/' + data.clue.id,
              query: { store_visit_id: this.store_visit_id }
            })
          } else {
            this.display = true
          }
        }
      })
    },
    createCustomerArchives () {
      let localData = cache.getSessionData(this.localArchivesDataKey)
      localData.customer.selectAuth = false
      localData.customer.mobile = this.mobile
      localData.customer.intention_cars = []
      localData.customer.contrast_cars = []
      localData.customer.intention_level = '5'
      cache.setSessionData(this.localArchivesDataKey, localData)
      this.$router.push({
        path: '/salemanage/staff/customerarchives',
        query: { store_visit_id: this.store_visit_id }
      })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
